export default {"src":"/_next/static/media/seamless-process.bbaa9ed1.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};